import "@andypf/json-viewer";

import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from "@angular/core";
import type { ContentBlockMetadata, ContentBlockRef } from "../../../../model/block.types";
import { FileBlockCardComponent } from "../file-block-card/file-block-card.component";

/**
 * Mandatory fallback for any `content_kind` without a dedicated renderer (content-blocks S5 §4.1)
 * — a download card when a file ref is present, otherwise a raw metadata dump. Guarantees every
 * mcp_tool block renders something, never throws.
 */
@Component({
  selector: "app-generic-content-card",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [FileBlockCardComponent],
  templateUrl: "./generic-content-card.component.html",
  styleUrl: "./generic-content-card.component.scss",
})
export class GenericContentCardComponent {
  label = input.required<string>();

  metadata = input.required<ContentBlockMetadata>();

  ref = input.required<ContentBlockRef | null>();
}
